export const validateHex = (string:string)=>{
    const regex = /^#[0-9A-Fa-f]{8}$/;
    return regex.test(string)&&string.length===9;
}